// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"235e9c48","133":"9836a8ef","182":"d97c99ad","261":"fe67f7b0"}[chunkId] + ".chunk.js";
};